import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RoundButton as ChameleonRoundButton } from '@getgo/chameleon-material-ui';
import classNames from 'classnames';
import TextTruncate from "../TextTruncate";
import { useRef } from 'react';
import { shouldInvertText, TOKEN_INVERSE_TEXT, TOKEN_PRIMARY_TEXT } from "../../utils/colors";
import classes from './index.module.scss';
const RoundButton = ({ className, color, disabled, label, variant = 'secondary', size, children, onClick, dataTestId, }) => {
    const ref = useRef(null);
    return (_jsxs("div", Object.assign({ ref: ref, className: classNames(classes.buttonContainer, className) }, { children: [_jsx(ChameleonRoundButton, Object.assign({ "data-testid": dataTestId, style: color
                    ? {
                        backgroundColor: color,
                        borderColor: color,
                    }
                    : null, className: classNames(classes.button, {
                    [classes.primary]: variant === 'primary',
                    [classes.secondary]: variant === 'secondary',
                    [classes.danger]: variant === 'danger',
                    [classes.success]: variant === 'success',
                    [classes.small]: size === 'small',
                    [classes.medium]: size === 'medium',
                    [classes.large]: size === 'large',
                    [classes.xlarge]: size === 'xlarge',
                    [classes.xxlarge]: size === 'xxlarge',
                    [classes.inverse]: color && shouldInvertText(TOKEN_INVERSE_TEXT, color, TOKEN_PRIMARY_TEXT, ref.current),
                }), disabled: disabled, variant: variant, size: size, onClick: onClick }, { children: children }), void 0), label && _jsx(TextTruncate, Object.assign({ className: classes.text }, { children: label }), void 0)] }), void 0));
};
export default RoundButton;
//# sourceMappingURL=index.js.map